import { useSetBreadcrumbEffect } from '../contexts/BreadcrumbContext';
import EditTeam from '../components/team/EditTeam';

const TeamSettingsView = () => {
  useSetBreadcrumbEffect([{ display: 'Team Settings' }], []);
  return <EditTeam />;
};

export default TeamSettingsView;
